var map = {
	"./ar/pages/statistics/sources.js": "db3d",
	"./de/pages/statistics/sources.js": "792c",
	"./en/pages/statistics/sources.js": "3387",
	"./es/pages/statistics/sources.js": "2eb4",
	"./fr/pages/statistics/sources.js": "ac99",
	"./ja/pages/statistics/sources.js": "bb85",
	"./pt/pages/statistics/sources.js": "862c",
	"./ru/pages/statistics/sources.js": "e828",
	"./tr/pages/statistics/sources.js": "9fdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "796b";